// Central config for WomensMatchDayLive.
// Anything wrapped in [BRACKETS] is a placeholder — replace with the real
// client value before launch. Nothing here is fabricated client information.

export const isPlaceholder = (value) => !value || value.startsWith("[");

export const SITE = {
  name: "WomensMatchDayLive",
  tagline: "Grassroots Women's Football Commentary & Live Coverage",
  url: "[CLIENT DOMAIN]",
  description:
    "WomensMatchDayLive brings live commentary and coverage to grassroots women's football in the UK — live streams, matchday fixtures, highlights and behind-the-scenes content.",
  defaultOgImage:
    "https://images.unsplash.com/photo-1711447395363-5595964fd7ab?crop=entropy&cs=srgb&fm=jpg&q=85",
  contactEmail: "[CLIENT EMAIL]",
  googleSiteVerification: "[GOOGLE-SEARCH-CONSOLE-VERIFICATION]",
  bingSiteVerification: "[BING-VERIFICATION-CODE]",
  ga4MeasurementId: "[GA4-MEASUREMENT-ID]",
  gtmContainerId: "[GTM-CONTAINER-ID]",
  facebookPixelId: "[OPTIONAL]",
  twitterHandle: "[X/TWITTER HANDLE]",
};

export const FORMSPREE_FORM_ID = process.env.REACT_APP_FORMSPREE_FORM_ID || "";

export const NAV_LINKS = [
  { label: "Home", path: "/" },
  { label: "Live", path: "/live", live: true },
  { label: "Matchday", path: "/matchday" },
  { label: "Content", path: "/content" },
  { label: "About", path: "/about" },
  { label: "Socials", path: "/socials" },
  { label: "Contact", path: "/contact" },
];

// Flip to true and fill in `match` once a fixture actually goes live.
export const STREAM_STATUS = {
  isLive: false,
  match: {
    homeTeam: "Team name goes here",
    awayTeam: "Team name goes here",
    competition: "Competition goes here",
    kickOff: "Kick-off time goes here",
    venue: "Venue goes here",
  },
  upcoming: "Upcoming live coverage information goes here.",
};

// Official embed methods only. TikTok does not currently offer an official
// LIVE embed, so it always falls back to a "watch on TikTok" link-out.
export const STREAM_PLATFORMS = [
  { id: "kick", name: "Kick", type: "kick", channel: "[KICK_CHANNEL]", channelUrl: "[KICK URL]", color: "#53FC18", enabled: true },
  { id: "twitch", name: "Twitch", type: "twitch", channel: "[TWITCH_CHANNEL]", channelUrl: "[TWITCH URL]", color: "#9146FF", enabled: true },
  { id: "youtube", name: "YouTube", type: "youtube", channel: "[YOUTUBE_VIDEO_ID]", channelUrl: "[YOUTUBE URL]", color: "#FF0000", enabled: true },
  { id: "tiktok", name: "TikTok", type: "tiktok", channel: "[TIKTOK_URL]", channelUrl: "[TIKTOK URL]", color: "#25F4EE", enabled: true },
];

export const SOCIAL_LINKS = [
  { id: "youtube", name: "YouTube", url: "[YOUTUBE URL]", handle: "[SOCIAL HANDLE]" },
  { id: "twitch", name: "Twitch", url: "[TWITCH URL]", handle: "[SOCIAL HANDLE]" },
  { id: "kick", name: "Kick", url: "[KICK URL]", handle: "[SOCIAL HANDLE]" },
  { id: "tiktok", name: "TikTok", url: "[TIKTOK URL]", handle: "[SOCIAL HANDLE]" },
  { id: "instagram", name: "Instagram", url: "[INSTAGRAM URL]", handle: "[SOCIAL HANDLE]" },
  { id: "x", name: "X (Twitter)", url: "[X URL]", handle: "[SOCIAL HANDLE]" },
  { id: "facebook", name: "Facebook", url: "[FACEBOOK URL]", handle: "[SOCIAL HANDLE]" },
];

export const ENQUIRY_TYPES = [
  "Match commentary",
  "Club enquiry",
  "Media enquiry",
  "Sponsorship",
  "Collaboration",
  "General enquiry",
];

export const CONTENT_CATEGORIES = [
  "Match Commentary",
  "Interviews",
  "Highlights",
  "Matchday Content",
  "Behind the Scenes",
  "Other",
];
